import React, { useState } from 'react';
import styled from 'styled-components';
import { FaTimes } from 'react-icons/fa';

// Styled components for the Size Chart
const Modal = styled.div`
  display: ${props => props.isOpen ? 'block' : 'none'};
  position: fixed;
  z-index: 1000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0,0,0,0.6);
`;

const ModalHeaderBar = styled.div`
  position: fixed;
  top: 30px;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  max-width: 800px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  z-index: 1001;
  pointer-events: none;
  
  @media screen and (max-width: 768px) {
    top: 15px;
    width: 95%;
  }
  
  @media screen and (max-width: 480px) {
    top: 10px;
  }
`;

const Logo = styled.img`
  height: 35px;
  filter: brightness(0) invert(0.8);
  pointer-events: auto;
  
  @media screen and (max-width: 768px) {
    height: 28px;
  }
`;

const CloseButton = styled.div`
  color: #000;
  font-size: 24px;
  font-weight: 300;
  cursor: pointer;
  background-color: #fff;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  pointer-events: auto;
  border: 1px solid #eee;
  
  &:hover {
    background-color: #f0f0f0;
  }
  
  @media screen and (max-width: 768px) {
    width: 32px;
    height: 32px;
    font-size: 22px;
  }
`;

const ModalContent = styled.div`
  background-color: #fff;
  margin: 80px auto 40px auto;
  padding: 35px 45px;
  border: none;
  width: 90%;
  max-width: 800px;
  box-shadow: 0 8px 25px rgba(0,0,0,0.15);
  border-radius: 6px;
  font-family: inherit;
  color: #333;
  position: relative;
  
  @media screen and (max-width: 768px) {
    padding: 25px 20px;
    margin: 60px auto 30px auto;
    width: 95%;
  }
  
  @media screen and (max-width: 480px) {
    margin: 50px auto 20px auto;
    padding: 20px 15px;
  }
`;

const SizeGuideHeader = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 35px;
  
  @media screen and (max-width: 768px) {
    margin-bottom: 25px;
  }
`;

const RulerIcon = styled.img`
  width: 45px;
  height: 45px;
  margin-right: 18px;
  
  @media screen and (max-width: 480px) {
    width: 35px;
    height: 35px;
    margin-right: 12px;
  }
`;

const SizeGuideText = styled.div`
  h2 {
    margin: 0 0 4px 0;
    font-size: 20px;
    font-weight: 500;
    color: #111;
    
    @media screen and (max-width: 768px) {
      font-size: 18px;
    }
    
    @media screen and (max-width: 480px) {
      font-size: 17px;
    }
  }
  
  p {
    margin: 0;
    font-size: 14px;
    color: #555;
    
    @media screen and (max-width: 480px) {
      font-size: 12px;
    }
  }
`;

const ChartUnitSelector = styled.div`
  margin-bottom: 20px;
  text-align: left;
  
  select {
    padding: 8px 12px;
    font-size: 15px;
    font-weight: 500;
    color: #444;
    border: 1px solid #ccc;
    border-radius: 4px;
    background-color: #fff;
    cursor: pointer;
    
    &:focus {
      outline: none;
      border-color: #888;
    }
    
    @media screen and (max-width: 768px) {
      font-size: 14px;
    }
    
    @media screen and (max-width: 480px) {
      font-size: 13px;
    }
  }
`;

const ChartMainContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
  margin-bottom: 35px;
  
  @media screen and (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    gap: 25px;
  }
`;

const IllustrationColumn = styled.div`
  flex: 0 0 220px;
  
  @media screen and (max-width: 768px) {
    flex-basis: auto;
    width: 60%;
    max-width: 200px;
    margin-bottom: 10px;
  }
  
  @media screen and (max-width: 480px) {
    width: 70%;
  }
`;

const PoloIllustration = styled.img`
  width: 100%;
  height: auto;
  display: block;
  border: 1px solid #f0f0f0;
`;

const TableColumn = styled.div`
  flex: 1;
  
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;

const SizeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 14px;
  
  th, td {
    text-align: left;
    padding: 10px 8px;
    border: none;
    color: #333;
    vertical-align: middle;
  }
  
  th {
    font-weight: 400;
    color: #666;
    padding-bottom: 10px;
    font-size: 13px;
  }
  
  tbody tr td {
    padding-top: 14px;
    padding-bottom: 14px;
  }
  
  tbody tr:nth-child(odd) {
    background-color: #f7f7f7;
  }
  
  tbody tr:nth-child(even) {
    background-color: #fff;
  }
  
  tbody td:first-child {
    font-weight: 500;
    color: #222;
  }
  
  @media screen and (max-width: 768px) {
    th, td {
      font-size: 13px;
      padding: 8px 6px;
    }
    
    tbody tr td {
      padding-top: 12px;
      padding-bottom: 12px;
    }
  }
  
  @media screen and (max-width: 480px) {
    th, td {
      font-size: 12px;
    }
    
    tbody tr td {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }
`;

const SeparatorLine = styled.hr`
  border: none;
  border-top: 1px solid #eaeaea;
  margin-top: 10px;
  margin-bottom: 25px;
`;

const ModalFooterNote = styled.p`
  font-size: 13px;
  color: #555;
  text-align: left;
  line-height: 1.6;
  
  @media screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

// Size Chart Component
const SizeChart = ({ isOpen, onClose, sizeChartData }) => {
  const [unit, setUnit] = useState('inches');
  
  // Default size data if none is provided
  const defaultSizeDataInches = [
    { size: "XS", chest: '43"', shoulder: '17"', length: '29.5"' },
    { size: "S",  chest: '45"', shoulder: '18"', length: '30.5"' },
    { size: "M",  chest: '47"', shoulder: '19"', length: '31"' },
    { size: "L",  chest: '49"', shoulder: '20"', length: '31.5"' },
    { size: "XL", chest: '51"', shoulder: '21"', length: '32"' },
    { size: "XXL",chest: '53"', shoulder: '22"', length: '32.5"' }
  ];

  const defaultSizeDataCm = [
    { size: "XS", chest: '109.2 cm', shoulder: '43.2 cm', length: '74.9 cm' },
    { size: "S",  chest: '114.3 cm', shoulder: '45.7 cm', length: '77.5 cm' },
    { size: "M",  chest: '119.4 cm', shoulder: '48.3 cm', length: '78.7 cm' },
    { size: "L",  chest: '124.5 cm', shoulder: '50.8 cm', length: '80.0 cm' },
    { size: "XL", chest: '129.5 cm', shoulder: '53.3 cm', length: '81.3 cm' },
    { size: "XXL",chest: '134.6 cm', shoulder: '55.9 cm', length: '82.6 cm' }
  ];
  
  // Use provided data or default data
  const sizeDataInches = sizeChartData?.sizeDataInches || defaultSizeDataInches;
  const sizeDataCm = sizeChartData?.sizeDataCm || defaultSizeDataCm;
  
  // Get the current size data based on selected unit
  const currentSizeData = unit === 'cm' ? sizeDataCm : sizeDataInches;
  
  // Close modal when clicking outside
  const handleOutsideClick = (e) => {
    if (e.target.classList && e.target.classList.contains('modal-overlay')) {
      onClose();
    }
  };
  
  return (
    <Modal isOpen={isOpen} onClick={handleOutsideClick} className="modal-overlay">
      <ModalHeaderBar>
        <Logo 
          src={sizeChartData?.logo?.url || "/images/TMZ L.png"} 
          alt="TMZ Logo" 
        />
        <CloseButton onClick={onClose}>
          <FaTimes />
        </CloseButton>
      </ModalHeaderBar>
      
      <ModalContent>
        <SizeGuideHeader>
          <RulerIcon 
            src={sizeChartData?.topThumbnail?.url || "/images/ruler-icon.png"} 
            alt="Ruler Icon" 
          />
          <SizeGuideText>
            <h2>SIZE GUIDE</h2>
            <p>it helps you find your perfect fit.</p>
          </SizeGuideText>
        </SizeGuideHeader>

        <ChartUnitSelector>
          <select 
            value={unit} 
            onChange={(e) => setUnit(e.target.value)}
          >
            <option value="inches">SIZE CHART (Inches)</option>
            <option value="cm">SIZE CHART (cm)</option>
          </select>
        </ChartUnitSelector>

        <ChartMainContent>
          <IllustrationColumn>
            <PoloIllustration 
              src={sizeChartData?.thumbnail?.url || "/images/size-guide.png"} 
              alt="Size Measurement Guide" 
            />
          </IllustrationColumn>
          
          <TableColumn>
            <SizeTable>
              <thead>
                <tr>
                  <th>SIZE</th>
                  <th>FULL CHEST</th>
                  <th>SHOULDER</th>
                  <th>LENGTH</th>
                </tr>
              </thead>
              <tbody>
                {currentSizeData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.size}</td>
                    <td>{item.chest}</td>
                    <td>{item.shoulder}</td>
                    <td>{item.length}</td>
                  </tr>
                ))}
              </tbody>
            </SizeTable>
          </TableColumn>
        </ChartMainContent>

        <SeparatorLine />

        <ModalFooterNote>
          Numbers are based upon actual body measurements and should be used for garments only if you want a very close fit.
        </ModalFooterNote>
      </ModalContent>
    </Modal>
  );
};

export default SizeChart; 